import React, { FC, useEffect, useState } from 'react';
import { WarningOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { AnyAction } from 'redux';
import { setRestartLoader } from '@/redux/slices/loaderSlice';
import './index.scss';

const ErrorView: FC = () => {
  const dispatch = useDispatch();
  const [ipAddress, setIpAddress] = useState<string>('');

  const getClientIP = async () => {
    try {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      setIpAddress(data.ip);
    } catch (error) {
      console.error("Couldn't fetch IP:", error);
      setIpAddress('Unknown');
    }
  };

  useEffect(() => {
    dispatch(setRestartLoader() as unknown as AnyAction);
    getClientIP();
  }, [dispatch]);

  return (
    <div className="error-container">
      <div className="error-content">
        <div className="error-text">
          <h1 className="error-title">Error</h1>
          <p className="error-message">Access Denied.</p>
          <p className="error-description">
            To protect the requested service, this request has been blocked or
            was unable to complete for other reasons.
          </p>
          <div className="error-details">
            <div className="details-row">
              <p className="details-label">Your IP Address:</p>
              <p className="details-value">{ipAddress || '-'}</p>
            </div>
          </div>
        </div>
        <div className="error-icon">
          <WarningOutlined
            style={{
              fontSize: '180px',
              fontWeight: 'bolder',
              color: 'grey',
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ErrorView;